<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    followUp: Object
  })

  const timeString = computed(() => {
    const followUp = props.followUp

    if (!followUp) return

    if (followUp.dates[0].startDate === followUp.dates[0].endDate) {
      return `${followUp.dates[0].weekday.slice(0, 3)}, ${followUp.dates[0].startTime} - ${followUp.dates[0].endTime} Uhr`
    }
    return `${followUp.dates[0].weekday.slice(0, 3)},  ${followUp.dates[0].startTime} - ${followUp.dates[0].endDay.slice(0, 3)} ${ followUp.dates[0].endTime } Uhr`
  })
</script>

<template>
<div
  v-if="followUp"
  class="follow-up mt-6"
>
  <p class="follow-up-title mb-4 ~text-sm/base">
    <strong>
      {{ followUp.headline }}
    </strong>
  </p>
  <p
    class="flex flex-row items-center mb-2"
  >
    <AppIcon
      name="EventDate"
      class="mr-2"
    ></AppIcon>
    <span
      v-if="followUp.dates[0].startDate === followUp.dates[0].endDate"
    >
      {{ followUp.dates[0].startDate }}
    </span>
    <span
      v-else
    >
      {{ followUp.dates[0].startDate }} - {{ followUp.dates[0].endDate }}
    </span>
  </p>
  <p
    class="flex flex-row items-center mb-2"
  >
    <AppIcon
      name="Clock"
      class="mr-2"
    ></AppIcon>
    <span>
        {{ timeString }}
    </span>
  </p>
</div>
</template>

<style lang="scss" scoped>

</style>
